import React from "react";
import { Button } from "../../../../components/ui/button";

export const PricingByAnima = (): JSX.Element => {
  return (
    <section
      id="pricing"
      className="flex flex-col md:flex-row items-start gap-8 md:gap-16 px-4 md:px-16 py-16 md:py-24 bg-white w-full"
    >
      <div className="flex flex-col items-start justify-center gap-8 md:gap-12 w-full md:flex-1">
        <div className="w-full flex flex-col items-start gap-6 md:gap-8">
          <div className="inline-flex items-center border text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-foreground px-4 py-2 rounded-[100px] border-[#169c79] opacity-[0.93]">
            <span className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-extrabold text-[#169c79] text-xs">
              PRICING
            </span>
          </div>
          <div className="flex flex-col items-start gap-4 w-full">
            <h2 className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-bold text-[#1a1a1a] text-2xl md:text-[40px] leading-tight md:leading-[60px]">
              Ready to Transform Travel Time?
            </h2>
            <p className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-normal text-[#595959] text-sm md:text-base leading-6">
              Get your Little Monsters Travel Kit today and turn "Are we there yet?" into hours of screen-free, imagination-fueled adventures at 30,000 feet or on the open road.
            </p>
          </div>
        </div>
        <div className="flex flex-col items-start gap-6 md:gap-8 w-full">
          <div className="flex items-center gap-4">
            <img
              className="w-7 md:w-7 h-7 md:h-7"
              alt="Dial off"
              src="/assets/dial-off.svg"
            />
            <span className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-normal text-black text-sm md:text-base leading-6">
              Free shipping on orders over ₹50
            </span>
          </div>
          <div className="flex items-center gap-4">
            <img
              className="w-7 md:w-7 h-7 md:h-7"
              alt="Dial off"
              src="/assets/dial-off.svg"
            />
            <span className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-normal text-black text-sm md:text-base leading-6">
              30-day happiness guarantee
            </span>
          </div>
          <div className="flex items-center gap-4">
            <img
              className="w-7 md:w-7 h-7 md:h-7"
              alt="Dial off"
              src="/assets/dial-off.svg"
            />
            <span className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-normal text-black text-sm md:text-base leading-6">
              Over 10,000 happy families (and counting!)
            </span>
          </div>
        </div>
        <div className="flex flex-col md:flex-row items-center gap-4 md:gap-3 w-full md:w-auto">
          <button
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-9 w-full md:w-[200px] px-6 py-3 rounded-[40px] border border-solid border-[#006E6A] shadow-[inset_0px_9px_19px_#006E6A] font-family:'Plus_Jakarta_Sans',Helvetica font-semibold text-white text-base"
            style={{
              background: "linear-gradient(to bottom, #0B7E7A, #003230)",
              borderColor: "#bb7ce4",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background =
                "linear-gradient(to bottom, #16A39C, #004A45)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background =
                "linear-gradient(to bottom, #0B7E7A, #003230)";
            }}
          >
            Order Kit : ₹29.99
          </button>

          <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 bg-background shadow-sm hover:bg-accent hover:text-accent-foreground h-9 w-full md:w-[200px] px-6 py-3 rounded-[40px] border border-solid border-[#006E6A] [font-family:'Plus_Jakarta_Sans',Helvetica] font-semibold text-[#006E6A] text-base">
            Learn more
          </button>
        </div>
      </div>
      <div className="border bg-card text-card-foreground flex-1 p-4 md:p-8 rounded-3xl shadow-[0px_8px_32px_#1a1a1a1f] border-none w-full">
        <div className="p-0 flex flex-col gap-6 md:gap-8">
          <div className="flex items-end gap-4 w-full">
            <div className="flex flex-col items-start gap-2 md:gap-4 flex-1">
              <h3 className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-semibold text-black text-xl md:text-2xl leading-[33.6px]">
                The Complete Monster Kit
              </h3>
              <p className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-normal text-black text-sm md:text-base leading-6">
                Everything your little explorer needs for travel entertainment
              </p>
            </div>
            <div className="flex items-end">
              <span className="[font-family:'Plus_Jakarta_Sans',Helvetica] font-extrabold text-black text-3xl md:text-5xl leading-[57.6px]">
                ₹29.99
              </span>
            </div>
          </div>
          <div
            data-orientation="horizontal"
            role="none"
            className="shrink-0 bg-border h-px w-full"
          ></div>
          <div className="flex flex-col items-start gap-4 w-full">
            <p className="[font-family:'Poppins',Helvetica] font-normal text-black text-sm md:text-base leading-6">
              Includes:
            </p>
            <div className="flex flex-col gap-4 md:gap-6 py-2 w-full">
              {/* List of items */}
              {[
                "12 premium colored pencils in a secure case",
                "25+ activity sheets (coloring, puzzles, games)",
                "Magnetic travel games with pieces",
                "32 storytelling cards with prompts",
                "Origami paper and instruction cards",
                "5 mystery surprise activity envelopes",
                "Durable, spill-resistant carrying case",
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-4 w-full">
                  <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center">
                    <img
                      className="w-6 h-6"
                      alt="Check"
                      src="/assets/Check.png"
                    />
                  </div>
                  <p className="flex-1 [font-family:'Plus_Jakarta_Sans',Helvetica] font-normal text-black text-sm md:text-base leading-6">
                    {item}
                  </p>
                </div>
              ))}
            </div>
          </div>
          <button
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap transition-all focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 h-9 w-full px-6 py-4 rounded-[40px] border border-solid border-[#006E6A] shadow-[inset_0px_9px_19px_#a870cc33] font-['Plus_Jakarta_Sans',Helvetica] font-semibold text-white text-base"
            style={{
              background: "linear-gradient(to bottom, #0B7E7A, #003230)",
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background =
                "linear-gradient(to bottom, #16A39C, #004A45)";
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background =
                "linear-gradient(to bottom, #0B7E7A, #003230)";
            }}
          >
            Add to Cart
          </button>
        </div>
      </div>
    </section>
  );
};
